import styled from 'styled-components';
import { styledTable } from '../styled/mixin';
import { Expense, ExpenseStatus, InsertType } from '../../modules/expenses';
import { Button, Col, Popconfirm, Row, Space, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { getExpenseType, priceToString } from '../../util/utils';
import Title from 'antd/lib/typography/Title';
import { EditOutlined, SyncOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface MyExpenseListComponentProps {
  data: Expense[] | null;
  syncCardApprovalLoading: boolean;
  onRegister: (expenseId: number) => void;
  onExclude: (expenseId: number) => void;
  syncCardApprovalList: () => void;
  openBulkEditDrawer: (idList: number[]) => void;
}

function MyExpenseListComponent({
  data,
  syncCardApprovalLoading,
  onRegister,
  onExclude,
  syncCardApprovalList,
  openBulkEditDrawer,
}: MyExpenseListComponentProps) {
  const [selectedValues, setSelectedValues] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any>([]);

  useEffect(() => {
    setSelectedValues([]);
  }, []);

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedValues([...selectedRowKeys]);
      setSelectedRows([...selectedRows]);
    },
    selectedRowKeys: selectedValues,
  };

  const columns: ColumnsType<Expense> = [
    {
      title: '상호명',
      dataIndex: 'companyName',
      defaultSortOrder: 'ascend',
      ellipsis: true,
      sorter: (a: Expense, b: Expense) =>
        a.companyName.localeCompare(b.companyName),
      width: '17%',
    },
    {
      title: '주소',
      dataIndex: 'companyAddress',
      ellipsis: true,
      width: '23%',
    },
    {
      title: '종류',
      dataIndex: ['financialAssetInfo', 'assetType'],
      width: '7%',
      // sorter: (a: Expense, b: Expense) =>
      //   getExpenseType(a)?.localeCompare(getExpenseType(b)),
      render: (text: any, record: any) => <>{getExpenseType(record)}</>,
    },
    {
      title: '등록일시',
      dataIndex: 'usedDate',
      ellipsis: true,
      width: '12%',
      render: (text: any, record: any, index: any) =>
        record.usedDate === null
          ? ''
          : moment(record.usedDateTime).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      title: '공급가액(원)',
      width: '10%',
      align: 'right',
      render: (value: any, record: any, index: any) =>
        priceToString(record.price - record.vat),
    },
    {
      title: '부가세(원)',
      dataIndex: 'vat',
      width: '9%',
      align: 'right',
      render: (value: any, record: any, index: any) => priceToString(value),
    },
    {
      title: '합계금액(원)',
      dataIndex: 'price',
      // sorter: (a: Expense, b: Expense) => a.price - b.price,
      width: '10%',
      align: 'right',
      render: (value: any, record: any, index: any) => priceToString(value),
    },
    {
      title: '',
      key: 'action',
      dataIndex: '',
      align: 'center',
      width: '8%',
      render: (text, record, index) => (
        <Space size="small">
          <Button size="small" onClick={() => onRegister(record.id)}>
            등록
          </Button>
          <div onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="정말 제외하시겠습니까?"
              onConfirm={() => onExclude(record.id)}
            >
              <Button size="small">제외</Button>
            </Popconfirm>
          </div>
        </Space>
      ),
    },
  ];

  // console.log(data);

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <Title level={5}>내 지출</Title>
        </Col>
        <Col>
          <Space>
            <Button
              size="small"
              loading={syncCardApprovalLoading}
              icon={<SyncOutlined rev={undefined} />}
              onClick={() => syncCardApprovalList()}
            >
              카드내역 가져오기
            </Button>
            <Button
              size="small"
              icon={<EditOutlined rev={undefined} />}
              loading={syncCardApprovalLoading}
              onClick={() => openBulkEditDrawer(selectedValues)}
              disabled={
                /**
                 * 1. 선택된 행이 없거나
                 * 2. 선택된 행이 있을 경우 선택된 모든 행의 insertType이 WITH_ASSET_DATA 이면서 선택된 모든 행의 expenseStatus 가 EDITING 이어야 한다.
                 */
                selectedValues.length === 0 ||
                selectedRows.some(
                  (row: any) =>
                    row.insertType !== InsertType.WITH_ASSET_DATA ||
                    row.expenseStatus !== ExpenseStatus.EDITING,
                )
              }
            >
              지출등록
            </Button>
          </Space>
        </Col>
      </Row>

      {data && (
        <Table<Expense>
          rowKey="id"
          columns={columns}
          dataSource={data}
          rowSelection={{ ...rowSelection, checkStrictly: false }}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
          locale={{
            triggerDesc: '내림차순으로 정렬하려면 클릭하세요.',
            triggerAsc: '오름차순으로 정렬하려면 클릭하세요.',
            cancelSort: '정렬을 취소하려면 클릭하세요.',
          }}
        />
      )}
    </StyledDiv>
  );
}

export default MyExpenseListComponent;
